import { WidgetMode } from "../constants";
import { CONTENTFUL_IDS } from "./constants";

const getContentfulMode = (widgetMode: WidgetMode) => {
  if (widgetMode === 'jobs-search') {
    return CONTENTFUL_IDS.jobSearchWidget;
  }
  if (widgetMode === 'quick-jobs') {
    return CONTENTFUL_IDS.quickJobs;
  }
  if (widgetMode === 'featured-jobs') {
    return CONTENTFUL_IDS.featuredJobs;
  }
};

export default getContentfulMode;